// extracted by mini-css-extract-plugin
module.exports = {"download-manager-container":"style_download-manager-container__YYy3s","download-manager-body-container":"style_download-manager-body-container__2h7mw"};